<template>
  <div class="table">
    <table>
      <tr>
        <th>学员Id</th>
        <td>{{ table.id }}</td>
        <th></th>
        <td></td>
      </tr>
      <tr>
        <th>学员姓名</th>
        <td>{{ table.username }}</td>
        <th>手机</th>
        <td>{{ table.mobile }}</td>
        <th>所属机构</th>
        <td>{{ table.schoole_name }}</td>
      </tr>
      <tr>
        <th>学员头像</th>
        <td>
          <el-image
            style="width: 100px; height: 100px"
            :src="table.avatar"
            fit="contain"
            :preview-src-list="[table.avatar]"
          >
          </el-image>
        </td>
        <th>邮箱</th>
        <td>{{ table.email }}</td>
      </tr>
      <tr>
        <th>性别</th>
        <td>{{ ["", "男", "女"][table.sex] }}</td>
        <th>出生日期</th>
        <td>{{ table.birthday }}</td>
      </tr>
      <tr>
        <th>家庭住址</th>
        <td>{{ table.home_addr }}</td>
        <th>现居住地</th>
        <td>{{ table.current_addr }}</td>
      </tr>
      <tr>
        <th>民族</th>
        <td>{{ table.nation }}</td>
        <th>籍贯</th>
        <td>{{ table.native_place }}</td>
      </tr>
      <tr>
        <th>政治面貌</th>
        <td>{{ table.political_outlook }}</td>
        <th>毕业院校</th>
        <td>{{ table.school }}</td>
      </tr>
      <tr>
        <th>专业</th>
        <td>{{ table.major }}</td>
        <th>学历</th>
        <td>{{ table.education }}</td>
      </tr>

      <tr>
        <th>证件类型</th>
        <td>{{ ["", "身份证", "驾驶证"][table.id_type] }}</td>
        <th>证件号码</th>
        <td>{{ table.id_no }}</td>
      </tr>
      <tr>
        <th>紧急联系人</th>
        <td>{{ table.emergency_contact }}</td>
        <th>紧急联络电话</th>
        <td>{{ table.emergency_phone }}</td>
      </tr>
      <tr>
        <th>健康状况</th>
        <td>
          {{ ["", "健康", "有遗传病史", "有慢性病史"][table.health_status] }}
        </td>
        <th>工作经历</th>
        <td>{{ table.experience }}</td>
      </tr>
    </table>
    <div class="btn">
      <el-button @click="toChange">修改</el-button>
      <el-button @click="$router.go(-1)">返回</el-button>
    </div>
  </div>
</template>

<script>
import { getStuListDetail } from "@/api/student.js";
export default {
  data() {
    return {
      table: {},
    };
  },
  created() {
    this.getStuListDetail();
  },
  methods: {
    toChange() {
      this.$router.push({
        path: "/student-add",
        query: { ...this.table, uuid: "x" },
      });
    },
    getStuListDetail() {
      getStuListDetail(this.$route.query.id).then((res) => {
        if (res && res.id) {
          this.table = res;
          this.$emit("getDetail", res);
        }
      });
    },
  },
};
</script>

<style scoped="scoped" lang="less">
table {
  line-height: 2;
  width: 80%;
  text-align: left;
  th {
    width: 16%;
  }
  td {
    width: 16%;
  }
}
.btn {
  border-top: 1px solid #bbb;
  padding-top: 10px;
  margin-top: 10px;
}
</style>
